import { FgBlockType } from '../../block-type.js';
import { fgQuaternionFromUpForward } from '../../fg-math.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { FgType } from '../../types.js';

const quaternionFromUpForwardDef = {
  type: FgBlockType.QuaternionFromUpForward,
  build: () => ({
    dataIn: [sockIn("a", FgType.Vector3), sockIn("b", FgType.Vector3)],
    dataOut: [sockOut("value", FgType.Quaternion)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", fgQuaternionFromUpForward(getDataValue(ctx, env, block, "a"), getDataValue(ctx, env, block, "b")));
  }
};

export { quaternionFromUpForwardDef };
//# sourceMappingURL=quaternion-from-up-forward.js.map
